// Backend implementation of Required Documents Repository

import RequiredDocumentsRepository from "@/core/customers/repositories/RequiredDocumentsRepository";
import {
  RequiredDocument,
  RequiredDocumentsResponse,
} from "@/core/customers/entities/RequiredDocuments";
import { getRequiredDocumentsUrl } from "../../api/requiredDocumentsEndpoints/requiredDocumentsEndpoints";
import { ApiResponse } from "../../api/types/ApiResponse";
import { ApiResponseHandler } from "../../http/services/handleApiResponse/handleApiResponse";
import { HttpClient } from "../../http/HttpClient";

export default class RequiredDocumentsRepositoryBackend
  implements RequiredDocumentsRepository
{
  constructor(private readonly httpClient: HttpClient) {}

  async getRequiredDocuments(
    businessKey: string
  ): Promise<RequiredDocumentsResponse> {
    try {
      console.log(
        "📄 RequiredDocumentsRepositoryBackend: Fetching required documents for",
        businessKey
      );

      const response = await this.httpClient.get<
        ApiResponse<RequiredDocument[]>
      >({
        url: getRequiredDocumentsUrl(businessKey),
        withAuth: true,
      });

      console.log(
        "📄 RequiredDocumentsRepositoryBackend: Response received",
        response
      );

      // Handle the standardized API response
      const result = ApiResponseHandler.handleResponse(response);

      if (result.success && result.data) {
        const requiredDocumentsResponse: RequiredDocumentsResponse = {
          success: true,
          message:
            (response as ApiResponse<RequiredDocument[]>).message ||
            "Documents requis récupérés avec succès",
          data: result.data,
        };

        return requiredDocumentsResponse;
      } else {
        return {
          success: false,
          message:
            result.message ||
            "Erreur lors de la récupération des documents requis",
          data: [],
        };
      }
    } catch (error) {
      console.error(
        "📄 RequiredDocumentsRepositoryBackend: Get required documents error",
        error
      );
      return {
        success: false,
        message: "Erreur réseau lors de la récupération des documents requis",
        data: [],
      };
    }
  }
}

